import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from '../../../../Core/Layout/FormLayoutTwo';
import Tab1 from './Tab1/Tab1';
import Tab2 from './Tab2/Tab2';
import Tab3 from './Tab3/Tab3';
import Tab4 from './Tab4/Tab4';
import { useSearchItemGroupMutation,useSearchHSNCodeMutation,useSearchBrandMutation,useSearchUOMMutation,useSearchItemTaxTemplateMutation,useSearchTaxCategoryMutation} from '../../../../store/api/auricsute_item_api';



import { usePageState } from "../../../../Hook/usePageState";

function CreateItemForm() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('tab1');

  // Default state for multiple tabs
  const pageStateDefault = {
    tab1: {
      item_Code: '',
      item_name: '',
      master_category: '',
      hsn_sac: '',
      brand: '',
      default_unit_of_measure: '',
      standard_selling_rate: '',
      nos: '',
      ows: '',
      disabled: false,
      maintain_stock: false,
      has_batch_no: false,
      has_serial_no: false,
      has_variants: false,
      description: "",
      quality_inspection_template: "",
      inspection_required_before_purchase: false,
      inspection_required_before_delivery: false,
      include_item_in_manufacturing: false,
      supply_raw_materials_for_purchase: false,
    },
    tab2: {
      shelf_life_in_days: '',
      end_of_life: '',
      default_material_request_type: '',
      valuation_method: '',
      warranty_Period_in_days: "",
      weight_per_unit: "",
      weigh_oum: "",
      allow_negative_stock: false
    },
    tab3: {
      default_purchase_uom: '',
      safety_stock: '',
      allow_purchase: false,
      minimum_order_qty: '',
      lead_time_in_days: '',
      is_customer_provided_item: false,
      country_of_origin: '',
      customs_tariff_number: ""
    },
    tab4: {
      default_sales_unit_of_measure: '',
      max_Discount: '',
      grant_commission: false,
      allow_sales: false,
    }

  };


  //   const createNewItemRow = () => ({
  //   item_code: "",
  //   item: {},
  //   required_by: "",
  //   quantity: 1,
  //   uom: "",
  //   rate: "0",
  //   amount: "0",
  // });

const [
  fetchMasterCategory,
  { data: masterCategoryData, isLoading: isMasterCategoryLoading, error: masterCategoryError },
] = useSearchItemGroupMutation();

const [
  fetchHSNCode,
  { data: hsnCodeData, isLoading: isHSNLoading, error: hsnError },
] = useSearchHSNCodeMutation();

const [
  fetchBrand,
  { data: brandData, isLoading: isBrandLoading, error: brandError },
] = useSearchBrandMutation();

const [
  fetchUOM,
  { data: uomData, isLoading: isUOMLoading, error: uomError },
] = useSearchUOMMutation();

const [
  fetchItemTaxTemplate,
  { data: itemTaxTemplateData, isLoading: isItemTaxTemplateLoading, error: itemTaxTemplateError },
] = useSearchItemTaxTemplateMutation();

const [
  fetchTaxCategory,
  { data: taxCategoryData, isLoading: isTaxCategoryLoading, error: taxCategoryError },
] = useSearchTaxCategoryMutation();

useEffect(() => {
  const fetchAllMasterData = async () => {
    try {
      // 🔹 Fetch Master Categories
      const masterCategoriesResponse = await fetchMasterCategory('').unwrap();
      console.log('Master Categories:', masterCategoriesResponse);

      // 🔹 Fetch GST HSN Codes
      const hsnCodesResponse = await fetchHSNCode('').unwrap();
      console.log('GST HSN Codes:', hsnCodesResponse);

      // 🔹 Fetch Brands
      const brandsResponse = await fetchBrand('').unwrap();
      console.log('Brands:', brandsResponse);

      // 🔹 Fetch UOMs
      const oum = await fetchUOM('').unwrap();
      console.log('oum:', oum);

      const temTaxTemplate = await fetchItemTaxTemplate('').unwrap();
      console.log('temTaxTemplate:', temTaxTemplate);

      const TaxCategory = await fetchTaxCategory('').unwrap();
      console.log('TaxCategory:', TaxCategory);
    } catch (err) {
      console.error('Error fetching master data:', err);
    }
  };

  fetchAllMasterData();
}, [fetchMasterCategory, fetchHSNCode, fetchBrand, fetchUOM]);




  const ItemColumnsTab1Table1 = [
    { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
    { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
    { title: "UOM", field: "oum", width: "35%" },
    { title: "Conversion Factor", field: "conversion_factor", width: "45%" },

  ];
  const ItemColumnsTab1Table2 = [
    { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
    { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
    { title: "Item Tax Template", field: "Item_tax_template", width: "15%" },
    { title: "Tax Category", field: "tax_category", width: "20%" },
    { title: "Valid From", field: "valid_from", width: "20%" },
    { title: "Minimum Net Rate", field: "minimum_net_rate", width: "20%" },
    { title: "Maximum Net Rate", field: "maximum_net_rate", width: "20%" },
  ];



  const ItemColumnsTab2Table1 = [
    { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
    { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
    { title: "Barcode", field: "barcode", width: "35%" },
    { title: "Barcode Type", field: "barcode_type", width: "45%" },
    { title: "UOM", field: "oum", width: "45%" },


  ];
  const ItemColumnsTab2Table2 = [
    { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
    { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
    { title: "Check in (group)", field: "check_in_group", width: "15%" },
    { title: "Request For", field: "request_for", width: "20%" },
    { title: "Re-order Level", field: "re_order_level", width: "20%" },
    { title: "Re-order Qty", field: "re_order_qty", width: "20%" },
    { title: "Material Request Type", field: "material_request_type", width: "20%" },
  ];


  const ItemColumnsTab3Table1 = [
    { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
    { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
    { title: "Supplier", field: "supplier", width: "35%" },
    { title: "Supplier Part Number", field: "supplier_part_number", width: "45%" },
  ];


  const ItemColumnsTab4Table1 = [
    { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
    { title: "Sl.No", field: "sl_no", width: "20px", align: "center" },
    { title: "Supplier", field: "supplier", width: "35%" },
    { title: "Supplier Part Number", field: "supplier_part_number", width: "45%" },
  ];

  const [pageState, setPageState] = usePageState("Item-create", pageStateDefault);

  const additionalData = {
    tab1: {
      mastercategory : masterCategoryData?.message,
      hsncodedata : hsnCodeData?.message,
      branddata : brandData?.message,
      uomdata : uomData?.message,
      itemtaxtemplatedata : itemTaxTemplateData?.message,
      taxcategorydata:taxCategoryData?.message,
      compnay: [{ "name": 'Malabar gold and diamonds',"dis" : "test" }],
      customer_types: [{ "name": 'Regular' }, { "name": 'VIP' }, { "name": 'Wholesale' }],
      assigned_to: [{ "name": 'Akash' }, { "name": 'Ajay' }, { "name": 'Sooraj' }],
      helped_by: [{ "name": 'Megha' }, { "name": 'Sulekha' }, { "name": 'Rahul' }],
      ItemColumnsTab1Table1: ItemColumnsTab1Table1,
      ItemColumnsTab1Table2: ItemColumnsTab1Table2
    },
    tab2: {
      countries: [{ name: 'India' }, { name: 'USA' }, { name: 'UK' }],
      ItemColumnsTab2Table1: ItemColumnsTab2Table1,
      ItemColumnsTab2Table2: ItemColumnsTab2Table2
    },
    tab3: {
      countries: [{ name: 'India' }, { name: 'USA' }, { name: 'UK' }],
      ItemColumnsTab3Table1: ItemColumnsTab3Table1,
    },
    tab4: {
      countries: [{ name: 'India' }, { name: 'USA' }, { name: 'UK' }],
      ItemColumnsTab4Table1: ItemColumnsTab4Table1,
    }

  };

  const tabs = [
    { id: 'tab1', label: 'General Details', component: Tab1 },
    { id: 'tab2', label: 'Inventory', component: Tab2 },
    { id: 'tab3', label: 'Purchasing', component: Tab3 },
    { id: 'tab4', label: 'Sales', component: Tab4 },



  ];

  // Generic function to update any field in any tab
  const updateTabField = (tab, field, value) => {
    console.log(tab, field, value, "check-came-data");

    setPageState({
      ...pageState,
      [tab]: {
        ...pageState[tab],
        [field]: value
      }
    });
  };

  const resetTabField = (tab) => {
    const emptyTabState = Object.keys(pageState[tab]).reduce((acc, key) => {
      acc[key] = typeof pageState[tab][key] === 'boolean' ? false : '';
      return acc;
    }, {});
    setPageState({
      ...pageState,
      [tab]: emptyTabState
    });
  };

  const resetAll = () => {
    Object.keys(pageState).forEach(tab => resetTabField(tab));
  };

  const handleSubmit = () => {
    console.log('Submitting:', pageState);
    // Send pageState to backend API
  };

  const getCurrentTabInfo = () => {
    const tabConfig = tabs.find(t => t.id === activeTab);
    if (!tabConfig) return null;
    return {
      component: tabConfig.component,
      data: pageState[activeTab],
      onChange: (field, value, type) => updateTabField(activeTab, field, value, type),
      extraData: additionalData[activeTab] || {}
    };
  };

  const currentTab = getCurrentTabInfo();
  const CurrentComponent = currentTab?.component;

  return (
    <FormLayoutTwo
      title="New Item"
      breadcrumbs={[{ label: "Item List", url: "/master/item/item-list-new" }]}
      status={'New'}
      actionButtons={
        <>
          <Button
            className="custom-btn-00989"
            iconName="LuFilePlus2"
            onClick={handleSubmit}
            iconSize={12}
          >
            Save
          </Button>
          <Button
            to="/brand/create-brand"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: '21px' }}
          />
        </>
      }
    >
      <div style={{ width: "100%", overflow: "hidden", backgroundColor: "#efefef", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end">
            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
              {tabs.map(tab => (
                <li key={tab.id} className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                  <a
                    className={`removeborder234 nav-link ${activeTab === tab.id ? 'active-tab-custom-new text-white' : 'tab-inactive-custom'} border-radius-top-corner`}
                    onClick={() => setActiveTab(tab.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    {tab.label}
                    <GetIcon iconName={activeTab === tab.id ? "MdKeyboardArrowDown" : "MdKeyboardArrowRight"} size={15} />
                  </a>
                </li>
              ))}
            </ul>
            <div className="d-flex align-items-center mb-2 px-3">
              <GetIcon iconName="CgAttachment" size={12} />
              <span className="fw-semibold ms-1" style={{ color: "#391F84" }}>
                Attachments
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {CurrentComponent && currentTab && (
              <CurrentComponent
                formData={currentTab.data}
                onFieldChange={currentTab.onChange}
                extraData={currentTab.extraData}
              />
            )}
          </div>
        </div>
      </div>
    </FormLayoutTwo>
  );
}

export default CreateItemForm;
